// Campaign constants
export const CAMPAIGN_CONFIG = {
  TARGET_DATE: new Date('2026-01-31T23:59:59'),
  START_DATE: new Date('2026-01-22T10:30:00'), // Default start date: 17th Dec 2025
  TITLE: 'Your Spending Just \n Got More Rewarding.',
  MARQUEE_TEXT: "Valentine's Day Campaign offer is ending soon!",
  CAMPAIGN_PERIOD: '17TH DEC - 1ST JAN',
  LEADERBOARD_POOL: '250,000 Sats',
};

// Reward levels configuration
export const REWARD_LEVELS = {
  LEVEL_ONE: {
    threshold: 50000,
    reward: 5000,
    label: '₹50,000',
  },
  LEVEL_TWO: {
    threshold: 100000,
    reward: 10000,
    label: '₹1,00,000',
  },
  TOTAL_THRESHOLD: 100000,
};

// Asset URLs
export const ASSET_URLS = {
  TIMER_ICON: 'https://assets.gosats.io/notification/2024/12/1734692217708',
  DECORATION_1: 'https://assets.gosats.io/notification/2025/12/1765862014193',
  DECORATION_2: 'https://assets.gosats.io/notification/2026/1/1769665271605',
  DECORATION_3: 'https://assets.gosats.io/notification/2025/12/1766468183308',
  DECORATION_4: 'https://assets.gosats.io/notification/2025/12/1766469116161',
  DECORATION_5: 'https://assets.gosats.io/notification/2025/12/1766468902024',
  DECORATION_6: 'https://assets.gosats.io/notification/2025/12/1765879118456',
  DECORATION_7: 'https://assets.gosats.io/notification/2025/12/1765866679762',
  DECORATION_8: 'https://assets.gosats.io/notification/2025/12/1765866680124',
  DECORATION_9: 'https://assets.gosats.io/notification/2025/12/1766472728966',
  DECORATION_10: 'https://assets.gosats.io/notification/2025/12/1765865798363',
  DECORATION_11: 'https://assets.gosats.io/notification/2025/12/1765883828534',
  DECORATION_12: 'https://assets.gosats.io/notification/2025/12/1765861532843',
};

// Styles
export const LOADER_STYLE = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: '#0F0F0F',
  zIndex: 1000,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

export const BUTTON_SPINNER_STYLE = {
  width: '20px',
  height: '20px',
  border: '2px solid #FFFFFF',
  borderRadius: '50%',
  borderTopColor: 'transparent',
  animation: 'spin 0.8s linear infinite',
  margin: '0 auto',
};
